var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamEffectiveness({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 20,
    height: 28,
    viewBox: "0 0 20 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_198",
    "data-name": "Rectangle 198",
    width: 20,
    height: 28,
    transform: "translate(0)",
    fill: "#065683"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_153",
    "data-name": "Group 153",
    transform: "translate(0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5323",
    "data-name": "Path 5323",
    d: "M11.355,5.62l-4.2,5.6a.688.688,0,0,1-.5.28H6.6a.656.656,0,0,1-.49-.21l-1.4-1.4a.692.692,0,1,1,.979-.979l.839.825L10.236,4.78a.7.7,0,0,1,1.119.839",
    transform: "translate(1.902 1.795)",
    fill: "#065683"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5324",
    "data-name": "Path 5324",
    d: "M11.215,4.641a.7.7,0,0,1,.14.979l-4.2,5.6a.688.688,0,0,1-.5.28H6.6a.656.656,0,0,1-.49-.21l-1.4-1.4a.692.692,0,1,1,.979-.979l.839.825L10.236,4.78a.7.7,0,0,1,.979-.14",
    transform: "translate(1.902 1.795)",
    fill: "#065683"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5325",
    "data-name": "Path 5325",
    d: "M9.793,0A9.786,9.786,0,0,0,4.9,18.263V26.58a1.4,1.4,0,0,0,2.269,1.091l2.627-2.1,2.633,2.1a1.411,1.411,0,0,0,.865.3,1.507,1.507,0,0,0,.606-.137,1.4,1.4,0,0,0,.793-1.262V18.263A9.786,9.786,0,0,0,9.793,0m0,2.8A6.995,6.995,0,1,1,2.8,9.793,7,7,0,0,1,9.793,2.8m-2.1,20.874V19.357a9.784,9.784,0,0,0,4.2,0v4.314L10.674,22.7a1.374,1.374,0,0,0-.886-.322,1.342,1.342,0,0,0-.866.312Z",
    transform: "translate(0.107)",
    fill: "#065683"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5326",
    "data-name": "Path 5326",
    d: "M11.355,5.62l-4.2,5.6a.688.688,0,0,1-.5.28H6.6a.656.656,0,0,1-.49-.21l-1.4-1.4a.692.692,0,1,1,.979-.979l.839.825L10.236,4.78a.7.7,0,0,1,1.119.839",
    transform: "translate(1.902 1.795)",
    fill: "#065683"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamEffectiveness);
export default __webpack_public_path__ + "static/media/team-effectiveness.c945c56a41c10584a9df41f510703557.svg";
export { ForwardRef as ReactComponent };